import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { AppButton } from '@pro-sto/ui';
import NotificationSettings from '@/components/NotificationSettings';
import { PaymentSchemeTemplatesSection } from '@/components/PaymentSchemeTemplatesSection';
import { usePlatform } from '@/hooks';
import { ROUTES } from '@/constants/routes';
import './SettingsPage.css';

/**
 * Страница настроек админ-панели
 */
const SettingsPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const platform = usePlatform();

  return (
    <div className="settings-page" data-testid="settings-page">
      <div className="settings-page__container">
        <header className="settings-page__header">
          <h1 className="settings-page__title">Настройки</h1>
          <p className="settings-page__description">
            Управление параметрами и настройками админ-панели
          </p>
        </header>

        <div className="settings-page__content">
          {/* Секция уведомлений */}
          <section className="settings-page__section" data-testid="settings-section-notifications">
            <NotificationSettings />
          </section>

          <section className="settings-page__section" data-testid="settings-section-payment-scheme-templates">
            <PaymentSchemeTemplatesSection />
          </section>

          {platform === 'desktop' ? (
            <section
              className="settings-page__section settings-page__section_shift-templates"
              data-testid="settings-section-shift-templates"
            >
              <div className="settings-page__shift-templates-header">
                <h2 className="settings-page__shift-templates-title">Шаблоны смен</h2>
                <AppButton
                  variant="secondary"
                  size="M"
                  onClick={() => navigate(ROUTES.SHIFT_TEMPLATE_NEW)}
                  data-testid="settings-open-shift-template"
                >
                  Редактировать шаблон смены
                </AppButton>
              </div>
            </section>
          ) : null}
        </div>
      </div>
    </div>
  );
});

SettingsPage.displayName = 'SettingsPage';

export default SettingsPage;
